import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import moment from "moment";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatArray = (arrayValue: any): string => {
  if (!Array.isArray(arrayValue)) {
    return "";
  }

  if (arrayValue.length) {
    return arrayValue.join(", ");
  }

  return "";
};

export const getFilterLabel = ({
  attributeName,
  attributeNameLabel,
  operator,
  operatorLabel,
  value,
  valueLabel,
}: {
  attributeName: string;
  attributeNameLabel: string;
  operator: string;
  operatorLabel: string;
  value: any;
  valueLabel: string;
}): string => {
  if (value === null) {
    value = "NONE";
  }
  if (!!value && value.length === 1 && value[0] === null) {
    value = "NONE";
  }

  return `${attributeNameLabel || attributeName} ${operatorLabel || operator} ${valueLabel || value}`;
};

export const formatDateAsMMDDYYYY = (dateString: string): string => {
  return moment(dateString).format("MM/DD/YYYY");
};

export const formatDateAsHyphenatedYYYYMMDD = (dateToFormat: string): string => {
  // if dateToFormat is already in YYYY-MM-DD format, return it
  if (dateToFormat.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateToFormat;
  }
  return dayjs(dateToFormat)
    .tz("America/Los_Angeles")
    .format("YYYY-MM-DD");
};

export const formatForApiToUTC = (dateToFormat: string): string => {
  // The API expects a UTC date in the format YYYY-MM-DD with an offset for local time
  return dayjs.utc(dateToFormat).format("YYYY-MM-DD hh:mm:ss");
};

export const formatFilterList = (filterList: any[]): any[] => {
  return filterList.map(
    ({
      attributeName,
      attributeNameLabel,
      dataType,
      operator,
      operatorLabel,
      value,
    }: {
      attributeName: string;
      attributeNameLabel: string;
      dataType: string;
      operator: string;
      operatorLabel: string;
      value: any;
    }) => ({
      attributeName,
      attributeNameLabel,
      dataType,
      operator,
      operatorLabel,
      value,
    })
  );
};

export const formatHtmlText = (text: string): string => {
  return text.replace(/\s+/g, " ").trim();
};

export const formatUsername = (
  username: string | null,
  userMap: Record<string, { firstName: string; lastName: string }>
): string => {
  if (username === null) {
    return "";
  }
  const user = userMap[username];

  if (!!user) {
    return `${user.firstName} ${user.lastName}`;
  }
  return `${username}`;
};

export const isJiraKey = (value: string | null | undefined): boolean => {
  return /^[A-Z]+-\d+$/.test(value ?? "");
};

export const stripPackTitlePrefix = (packTitle: string): string => {
  if (!packTitle) {
    return "";
  }
  return packTitle.replace(/^critical fix[\W]+/i, "");
};

export const formatUTCtoPST = (dateToFormat: string): string => {
  return (
    dayjs(dateToFormat)
      .utc()
      .tz("America/Los_Angeles")
      .format("MM/DD/YYYY hh:mm a") + " PST"
  );
};
